import { IS_MOBILE, IS_WINDOWS } from 'src/helpers/environment';

export const ESTIMATED_ALWAYS_VISIBLE_SCROLLBAR_WIDTH = estimateAlwaysVisibleScrollbarWidth();

/** Whether the native scrollbar is always visible. */
export const ALWAYS_VISIBLE_SCROLLBAR = !!ESTIMATED_ALWAYS_VISIBLE_SCROLLBAR_WIDTH;

/** Whether the custom scrollbar should be narrow. */
export const SLIM_SCROLLBARS =
  !ESTIMATED_ALWAYS_VISIBLE_SCROLLBAR_WIDTH && (IS_WINDOWS || IS_MOBILE);

/** Whether the custom scrollbar should have clickable scroll buttons. */
export const SCROLL_BUTTONS = IS_WINDOWS;

/**
 * The width of the custom scrollbar when not slim. This is also used for slim scrollbars while
 * hovering over them.
 */
export const CUSTOM_SCROLLBAR_STANDARD_WIDTH = Math.max(
  15,
  ESTIMATED_ALWAYS_VISIBLE_SCROLLBAR_WIDTH
);

/** The default width of the custom scrollbar. */
export const CUSTOM_SCROLLBAR_WIDTH = SLIM_SCROLLBARS ? 9 : CUSTOM_SCROLLBAR_STANDARD_WIDTH;

/**
 * Determine whether the operating system is configured to always show a scrollbar, and if so,
 * return the width of this scrollbar. Note that this may not work consistently on all platforms,
 * so treat it as a progressive enhancement only.
 */
function estimateAlwaysVisibleScrollbarWidth(): number {
  const scrollTestElememnt = document.createElement('div');
  scrollTestElememnt.inert = true;
  scrollTestElememnt.style.overflow = 'scroll';
  try {
    document.body.append(scrollTestElememnt);
    return scrollTestElememnt.offsetWidth - scrollTestElememnt.clientWidth;
  } finally {
    scrollTestElememnt.remove();
  }
}
